import { Card, Divider, notification } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import TableTimesheet from "./components/TableTimesheet";
import { getUser } from "utils/index";
import shopApi from "api/shop";
import { useEffect, useMemo, useState } from "react";
import { roles } from "constants/index";
import { useTranslation } from "react-i18next";
import ModalHoliday from "./components/ModalHolyday";

const cx = classNames.bind(style);

export default function Admin() {
  const [api, contextHolder] = notification.useNotification();
  const { t } = useTranslation()

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const user = getUser();
  const [listShop, setListShop] = useState([]);
  const [listShopUser, setListShopUser] = useState({});

  const getShopByRole = async () => {
    try {
      const res = await shopApi.getShopByRole({ is_timesheet: true });
      if (res.success) {
        const listUser = [
          ...new Set(
            res.shops.map((shop) => (shop?.user?._id ? shop.user : null)).filter((user) => user)
          ),
        ];

        const listShopUserRes = {};

        listUser.forEach((user) => {
          listShopUserRes[user._id] = res.shops.filter((shop) => shop?.user?._id == user._id);
        });

        setListShopUser(listShopUserRes);

        setListShop(res.shops.filter((shop) => !shop?.user));
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  useEffect(() => {
    getShopByRole();
  }, []);

  // const { shops } = getUser();

  return (
    <div className={cx("page-timesheet")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t('timesheet')}</p>
        {
          user.role == roles.admin &&
          <ModalHoliday openNotificationWithIcon={openNotificationWithIcon} getShopByRole={getShopByRole} />
        }
      </div>
      {(user.role == roles.shopManager || user.role == roles.areaManager) &&
        listShop?.map((item, index) => (
          <TableTimesheet
            key={index}
            shop={item.shop._id}
            name={item.shop.name}
            openNotificationWithIcon={openNotificationWithIcon}
          />
        ))}
      {([roles.admin, roles.departmentManager, roles.springer].includes(+user.role)) && (
        <>
          {Object.values(listShopUser).map((values, index) => (
            <Card hoverable key={index} style={{ marginBottom: 20 }}>
              {
                <>
                  <p className={cx("title-store")}>{`${t('manager')}: ${values[0].user.name}`}</p>
                  {values.map((item) => {
                    return (
                      <>
                        <TableTimesheet
                          key={item.shopId}
                          shop={item.shopId}
                          name={item.shopName}
                          openNotificationWithIcon={openNotificationWithIcon}
                          isShop
                        />
                        <Divider />
                      </>
                    );
                  })}
                </>
              }
            </Card>
          ))}
          {listShop?.map((item, index) => {
            return (
              <Card key={index} style={{ marginBottom: 20 }}>
                <TableTimesheet
                  shop={item.shopId}
                  name={item.shopName}
                  openNotificationWithIcon={openNotificationWithIcon}
                  isShop={user.role != roles.springer}
                />
              </Card>
            );
          })}
        </>
      )}
    </div>
  );
}
